/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLoading3Filled: {
  name: 'loading-3-filled';
  data: string;
} = {
  name: 'loading-3-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11 1.547a10.58 10.58 0 0 0-5.608 2.296c-.356.285-.783.704-.889.873-.642 1.026.17 2.361 1.384 2.274.377-.027.675-.185 1.193-.634a7.018 7.018 0 0 1 1.66-1.097c1.004-.484 1.857-.695 3.078-.759.695-.036.878-.104 1.226-.456.332-.335.442-.598.442-1.05 0-.62-.349-1.144-.917-1.378-.208-.086-.283-.094-.829-.089-.33.003-.663.012-.74.02"/></svg>`
};
